import React, {Component} from 'react';
import {CONFIG} from "../config";
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {
    onChangeForm,
    setLocale,
    setUser,
    setUserData,
    setInvoiceNeeded
} from "../../booking_engine/actions/summaryActions"

import {
    setAllTranslations
} from "../../booking_engine/actions/translationsAction"
import PrimaryBox from "../../booking_engine/components/PrimaryBox";
import TabsNav from "../../booking_engine/components/Tabs/TabsNav";
import TabContent from "../../booking_engine/components/Tabs/TabContent";
import LoginForm from "../../booking_engine/components/UserData/LoginForm";
import RegisteredUserForm from "../../booking_engine/components/UserData/RegisteredUserForm";
import RegisterForm from "../../booking_engine/components/UserData/RegisterForm";
import {getBookingEngineTranslations} from "../../functions/helpers";
import Loading from "../../booking_engine/components/Loading";
import {bindActionCreators} from "redux";
import countryListPL from "../../booking_engine/constants/countryListPL";
import countryListEN from "../../booking_engine/constants/countryListEN";
import countryListDE from "../../booking_engine/constants/countryListDE";
const translations = getBookingEngineTranslations()

class VoucherPayment extends Component {
    state = {
        administrator_personal_data_showed: false,
        activeTab: 0,
        user: {},
        isPaymentLoading: false,
        formErrors: [],
        validationError: false,
        validationErrorMessage: null
    }

    registerFormRef = React.createRef();
    registeredUserFormRef = React.createRef();

    componentWillMount() {
        const store = this.context.store;
        const {
            locale,
            user_id,
            session,
            setLocale,
        } = this.props;

        setLocale(locale);
        this.props.setAllTranslations(getBookingEngineTranslations())

        if (user_id > 0) {
            this.getUserData()
        }
    }

    getUserData = () => {
        const {translations} = this.props.store.translations
        const url = `${location.origin}${CONFIG.getUserDataEndpoint}?`

        fetch(url, {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
        })
        .then(response => response.json())
        .then(res => {
            this.props.setUser(res.payload)
        })
        .catch(error => {
            alert(`${translations['error-message']} ${error}`)
        })
    }

    getFormRef = () => {
        const {user} = this.props
        const formRef = user.id ? this.registeredUserFormRef : this.registerFormRef

        return formRef.current
    }

    submitFormRef = () => {
        const formRef = this.getFormRef()

        return Promise.resolve(formRef ? formRef.executeSubmit() : true)
            .then(response => {
                return response;
            })
    }

    decodeHtml = html => {
        const translate_re = /&(nbsp|amp|quot|lt|gt);/g;
        const translate = {
            "nbsp": " ",
            "amp": "&",
            "quot": "\"",
            "lt": "<",
            "gt": ">"
        };
        return html.replace(translate_re, function (match, entity) {
            return translate[entity];
        }).replace(/&#(\d+);/gi, function (match, numStr) {
            const num = parseInt(numStr, 10);
            return String.fromCharCode(num);
        });
    }

    text_administrator_personal_data = () => {
        return (
            <span
                className={this.state.administrator_personal_data_showed ? '' : 'hide'}>{translations['rodo-excerpt-end']}</span>
        )
    }

    showAdministratorPersonalData = () => {
        this.setState({
            administrator_personal_data_showed: true
        })
    }

    listUserTabs = () => {
        const {user} = this.props.store.summary
        return user.id ? [] : [
            translations['user-data-login'],
            translations['user-data-register']
        ]
    }

    handleTabClick = (tabID) => {
        this.submitFormRef()
            .then(() =>
                this.setState({
                    activeTab: tabID,
                    formErrors: []
                })
            )
    }

    prepareUserRequestData = () => {
        const {user} = this.props.store.summary
        const userAdditionals = ['tel', 'email', 'emailConfirm', 'consents', 'comments']
        const userAddress = {}
        const invoiceAddress = {}
        const invoiceKeyPrefix = 'invoice_'

        if (user.country.length > 2) {
            user.country = this.getIsoLangCode(user.country)
        }

        if (user.invoice_country.length > 2) {
            user.invoice_country = this.getIsoLangCode(user.invoice_country)
        }

        for (let key in user) {
            if (userAdditionals.includes(key)) continue

            if (key.includes(invoiceKeyPrefix)) {
                let invoiceKey = key.replace(invoiceKeyPrefix, '')
                invoiceAddress[invoiceKey] = user[key]
            } else {
                userAddress[key] = user[key]
            }
        }

        return {
            address: {
                ...userAddress,
            },
            invoice_address: {
                ...invoiceAddress,
            },
            contact: {
                tel: user.tel,
                email: user.email
            },
            consents: user.consents
        }
    }

    getIsoLangCode = label => {
        const countryList = this.getCountryList()
        const countryByLabel = countryList.filter(country => country.label.toLocaleLowerCase() === label)[0]
        return countryByLabel.value
    }

    getCountryList = () => {
        if (this.props.locale === 'pl') {
            return countryListPL
        } else if (this.props.locale === 'en') {
            return countryListEN
        } else if (this.props.locale === 'de') {
            return countryListDE
        }
    }

    redirectToPayments = () => {
        const {user} = this.props.store.summary

        const formErrors = [];
        const formRef = this.getFormRef()

        if (formRef) {
            const formValues = formRef.state.values
            const formValuesEmpty = !user.id && !Object.values(formValues).filter(value => value.length).length
            const formConsentsEmpty = !user.id && !formValues.consents.includes(42)
            const formHasErrors = Object.keys(formRef.state.errors).length

            if (formValuesEmpty || formHasErrors) formErrors.push(translations['form-error-required'])
            if (formConsentsEmpty) formErrors.push(translations['form-error-consents'])
        } else {
            if (!user.id) {
                formErrors.push(translations['form-error-required'])
            }
        }

        const userExist = !!user.id;

        this.setState({
            formErrors: [
                ...formErrors
            ]
        })

        if (this.state.formErrors.length) return

        const requestParams = {
            session: this.props.session,
            type: this.props.type_id,
            user: {
                exist: userExist,
                customerComments: user.comments,
                ...this.prepareUserRequestData(),
                invoice_needed: this.props.store.summary.invoiceNeeded
            },
        }

        this.setState({
            isPaymentLoading: true,
            validationError: false,
            validationErrorMessage: null
        }, () => {
            fetch(
                CONFIG.bookingEndpoint,
                {
                    method: 'post',
                    headers: {
                        Accept: 'application/json, text/plain, */*',
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(requestParams),
                },
            )
            .then(res => {
                return res.json()
            })
            .then(data => {
                if (data.status === false) {
                    this.setState({
                        isPaymentLoading: false,
                        validationError: true,
                        validationErrorMessage: data.message
                    });
                    return;
                }

                setTimeout(() => {
                    if (data.status) {
                        window.location.replace(data.payload.payment_link)
                    } else {
                        window.location.replace(data.payload.url)
                    }
                }, 500);

            })
        })
    }

    setFormRefTouched = () => {
        const formRef = this.getFormRef()

        if (formRef) {
            const formFields = formRef.fields
            let touchedValues = {}

            return Promise.resolve(
                Object.keys(formFields).forEach(field => {
                    if (field !== 'consents') {
                        touchedValues = {
                            ...touchedValues,
                            [field]: true
                        }
                    }

                    formRef.setTouched(touchedValues)
                })
            )
        }

        return Promise.resolve(true)
    }

    renderFormErrors = () => {
        const {formErrors} = this.state

        if (!formErrors.length) return

        return formErrors.map((error, i) =>
            <div key={`error-${i}`} className="alert alert-error">{error}</div>
        )
    }

    render() {
        let activeTab = this.state.activeTab
        const state = this.props.store
        const {isPaymentLoading} = this.state
        const translations = getBookingEngineTranslations();
        const {
            user,
            invoiceNeeded,
        } = this.props;

        return (
            <div className="cart__content">
                <div className="cart__content__column cart__content__column--wide">
                    <PrimaryBox
                        heading={translations['user-data']}
                        className="supplements log-in-form"
                    >
                        <div className="tabs">
                            <TabsNav
                                activeTab={activeTab}
                                onTabClick={this.handleTabClick}
                                tabs={this.listUserTabs()}
                                countSupplements={false}
                            />
                            <TabContent>
                                <div className="user_box--container">
                                    {activeTab === 0 ?
                                        !user.id ?
                                            <LoginForm/>
                                            :
                                            <RegisteredUserForm
                                                initialValues={user}
                                                onSubmit={values => this.props.setUserData(values)}
                                                ref={this.registeredUserFormRef}
                                                invoiceNeeded={invoiceNeeded}
                                            />
                                        :
                                        <RegisterForm
                                            initialValues={user}
                                            onSubmit={values => this.props.setUserData(values)}
                                            ref={this.registerFormRef}
                                            invoiceNeeded={invoiceNeeded}
                                        />
                                    }
                                </div>
                            </TabContent>
                        </div>
                    </PrimaryBox>
                </div>
                <div className="cart__content__column cart__content__column--narrow">
                    <PrimaryBox
                        heading={translations['box-heading-confirm']}
                        className="primary-box--relative payments"
                    >
                        {isPaymentLoading && <Loading text={translations['preloader-default']}/>}
                        <button
                            onClick={() => this.setFormRefTouched()
                                .then(() => this.submitFormRef())
                                .then(() => this.redirectToPayments())
                            }
                            className='btn_vc btn_vc--fullwidth'
                        >
                            {translations['payments-redirect']}
                        </button>
                        {this.renderFormErrors()}
                        {(this.state.validationError) &&
                        <div className="alert alert-error">{this.state.validationErrorMessage}</div>}
                        <br/>
                        <div className="small_test">
                            <strong>
                                <small>{translations['rodo-title']}</small>
                            </strong>
                            <br/>
                            <small>
                                <span dangerouslySetInnerHTML={{__html: this.decodeHtml(translations['rodo-excerpt'])}}/>
                                <a
                                    href="#" rel="nofollow"
                                    className={this.state.administrator_personal_data_showed ? 'hide' : ''}
                                    onClick={() => this.showAdministratorPersonalData()}
                                >
                                    {translations['more']}
                                </a>
                                {this.text_administrator_personal_data()}
                            </small>
                        </div>
                    </PrimaryBox>
                </div>
            </div>
        )
    }
}

VoucherPayment.contextTypes = {
    store: PropTypes.object,
}

const mapStateToProps = state => {
    const {
        isInvoiceNeeded,
        user,
        session,
        invoiceNeeded,
    } = state.summary;
    return {
        store: state,
        storeSummary: state.summary,
        isInvoiceNeeded,
        user,
        invoiceNeeded
    }
}

const mapDispatchToProps = dispatch => bindActionCreators(
    {
        setAllTranslations,
        onChangeForm,
        setLocale,
        setUser,
        setUserData,
        setInvoiceNeeded
    },
    dispatch
)

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(VoucherPayment)